module.exports = __webpack_public_path__ + "img/doc.b231fe1.svg";